export const MachidukuriSummary = [
  {
    title: "1. まちづくりのコンセプト",
    images: ["/images/news-machidukuri-1-1.jpg"]
  },
  {
    title: "2. スマートサービス",
    images: ["/images/news-machidukuri-2-1.jpg", "/images/news-machidukuri-2-2.jpg"]
  },
  {
    title: "3. 都市空間",
    images: ["/images/news-machidukuri-3-1.jpg"]
  },
  {
    title: "4. 都市機能",
    images: ["/images/news-machidukuri-4-1.jpg", "/images/news-machidukuri-4-2.jpg"]
  },
  {
    title: "5. まちづくりのマネジメント",
    images: ["/images/news-machidukuri-5-1.jpg"]
  }
];